import React from 'react';
import Style from './About.module.css';
import { Row, Col } from 'react-bootstrap';
import { Progress } from '@chakra-ui/react';

function AboutPage() {
  return (
    <>
      <Row>
        <Col>
          <div className={Style.body}>
            <div className={Style.title}>About me</div>
            <div className={Style.subtitle}>
              - Profesionally connected with the web develepment and mobile
              technology industry for many years
              <br />
              - Well-organised person,problem solver,independent employee with
              high attention
              <br />
              - to details.I love to pick-up new challenges and always looking
              for better ways to do things
              <br />- I love football,movies and travelling is a major part of
              my activities I am always anticipating.
            </div>
            <div className={Style.subtitle}>
              I am interested in the entire frontend spectrum and working on
              ambitious projects with positive people.
            </div>
          </div>
        </Col>

        <Col className={Style.spacecol}>
          <Progress
            isIndeterminate
            className='mt-5'
            size='sm'
            colorScheme='pink'
            value={100}
          />
          <Progress
            isIndeterminate
            className='mt-5'
            size='sm'
            colorScheme='gray'
            value={80}
          />
          <Progress
            isIndeterminate
            size='sm'
            className='mt-5'
            colorScheme='gray'
            value={60}
          />
          <Progress
            isIndeterminate
            size='sm'
            className='mt-5'
            colorScheme='gray'
            value={40}
          />
          <Progress
            isIndeterminate
            size='sm'
            className='mt-5'
            colorScheme='gray'
            value={20}
          />
        </Col>
      </Row>
    </>
  );
}

export default AboutPage;
